export function atobFunc(str = '') {
  if (process.server) return Buffer.from(str, 'base64').toString();
  return atob(str);
}

export function btoaFunc(str = '') {
  if (process.server) return Buffer.from(str).toString('base64');
  return btoa(str);
}

export function jsonToBase64Url(jsonObject = {}) {
  const base64Str = btoaFunc(JSON.stringify(jsonObject));
  return base64Str
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=/g, '');
}

export function base64UrlToJson(str = '') {
  const base64Str = (str + '==='.slice((str.length + 3) % 4)).replace(/-/g, '+').replace(/_/g, '/');
  return JSON.parse(atobFunc(base64Str));
}

export default { jsonToBase64Url, base64UrlToJson };
